import React from "react";
const UserDetails = ({ userInfo, area, image }) => {
  let serial = 1;
  return (
    <div>
      <h3>Quotation Details For:</h3>
      <table style={{ width: "100%" }}>
        <thead>
          <tr>
            <th style={{ width: "5%" }}>Sr.</th>
            <th style={{ width: "30%" }}>Item</th>
            <th>Description</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{serial++}</td>
            <td>Contact Details</td>
            <td>{`M/s. ${userInfo.contactPersonName}` || "N/A"}</td>
          </tr>
          <tr>
            <td>{serial++}</td>
            <td>Business Details</td>
            <td>
              Name:{`${userInfo?.businessName}` || "N/A"} GST:{" "}
              {`${userInfo?.gstNumber}` || "N/A"}
            </td>
          </tr>
          <tr>
            <td>{serial++}</td>
            <td>Site location</td>
            <td>{`${userInfo?.address}` || "N/A"}</td>
          </tr>

          <tr>
            <td>{serial++}</td>
            <td>Construction size</td>
            <td>
              {`Bay:${
                userInfo?.bay_size ? `${userInfo?.bay_size}Mtr` : "N/A"
              }, Span:${
                userInfo?.span_size ? `${userInfo?.span_size}Mtr` : "N/A"
              }, Area: ${
                area?.area_in_sqmeter ? `${area?.area_in_sqmeter}SqMtr` : "N/A"
              } ${area?.area_in_sqft ? `(${area?.area_in_sqft}SqFt)` : ""}`}
            </td>
          </tr>

          {userInfo?.quotationType !== "hydroponics only" &&
            userInfo?.quotationType !== "fanpad" &&
            userInfo?.quotationType !== "nvph" &&
            userInfo?.quotationType !== "nethouse" &&
            userInfo?.quotationType !== "soilbasedfanpad" &&
            userInfo?.quotationType !== "soilbasednvph" &&
            userInfo?.quotationType !== "soilbasednethouse" && (
              <tr>
                <td>{serial++}</td>
                <td>Hydroponic Percentage</td>
                <td>
                  {`A-frame:${userInfo?.a_FramePercent || 0}%, Flat-NFT:${
                    userInfo?.flatBedPercent || 0
                  }%, Grow bag:${
                    userInfo?.growBagPercent || 0
                  }%, Dutch Bucket:${userInfo?.dutchBucketPercent | 0}%` ||
                    "N/A"}
                </td>
              </tr>
            )}
        </tbody>
      </table>
      {image != "visible" ? (
        <div style={{ width: "100%" }}>
          <img
            src={
              "https://res.cloudinary.com/bsgfcooa/image/upload/v1753080667/hthd_wfcbvp_l9knae_emtbey.png"
            }
            width={"100%"}
            alt="kryzenCertificates"
          />
        </div>
      ) : (
        ""
      )}
      <div
        className="html2pdf__page-break"
        style={{ pageBreakAfter: "always", display: "block", clear: "both" }}
      ></div>
    </div>
  );
};

export default UserDetails;
